import { useQuery } from "react-query";
import { fetchData } from "../api/client";

export const DASHBOARD_FINANCE_ATTENDANCE_READINESS_KEY = [
  "dashboard",
  "financeiro-atendimento",
  "readiness",
];

/**
 * Aba Custos só faz sentido com salário cadastrado em cargo ou usuário.
 */
export function useDashboardFinanceAttendanceReadiness() {
  return useQuery(
    DASHBOARD_FINANCE_ATTENDANCE_READINESS_KEY,
    async () => {
      const res = await fetchData("/dashboard/financeiro-atendimento/readiness");
      // fetchData envelopa o payload em `{ data: T }`
      return Boolean(res?.data?.configured ?? res?.configured);
    },
    {
      staleTime: 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    }
  );
}
